import model from './model';

export enum ElementId {
  Price = '#price',
  Currency = '#currency',
  Frequency = '#frequency',
  SetupFee = '#setupFee',
}

export interface PricingData {
  price: string;
  currency: string;
  paymentFrequency: string;
  setupFee: string;
}

export interface PricingElementOptions {
  forceExpandFrequency?: boolean;
  forceExpandSetupFee?: boolean;
}

export default model.createController(({ $w }) => {
  return {
    pageReady: async () => {},
    exports: {
      setPricing: (
        { price, currency, paymentFrequency, setupFee }: PricingData,
        elementOptions?: PricingElementOptions,
      ) => {
        $w(ElementId.Price).text = price;
        $w(ElementId.Currency).text = currency;

        if (paymentFrequency) {
          $w(ElementId.Frequency).text = paymentFrequency;
          $w(ElementId.Frequency).expand();
        } else {
          $w(ElementId.Frequency).text = '';
          $w(ElementId.Frequency).collapse();
        }

        if (setupFee) {
          $w(ElementId.SetupFee).text = setupFee;
          $w(ElementId.SetupFee).expand();
        } else {
          $w(ElementId.SetupFee).collapse();
          $w(ElementId.SetupFee).text = '';
        }

        if (elementOptions?.forceExpandFrequency) {
          $w(ElementId.Frequency).expand();
        }
        if (elementOptions?.forceExpandSetupFee) {
          $w(ElementId.SetupFee).expand();
        }
      },
    },
  };
});
